import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=778b80e6"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('778b80e6')) {
      api.createRecord('778b80e6', component.options)
    } else {
      api.reload('778b80e6', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=778b80e6", function () {
      api.rerender('778b80e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/completion-reports/Page.vue"
export default component.exports